export default __webpack_public_path__ + "static/media/sin3.c6908430.webp";